/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Font_Family_AriaInputs */

const en_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Family Selection`)
};

const fr_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection de la famille de police`)
};

const de_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftfamilienauswahl`)
};

const it_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione della famiglia di caratteri`)
};

const ru_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор семейства шрифтов`)
};

const es_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de la familia de fuentes`)
};

const zh_cn2_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体系列选择`)
};

const ja_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントファミリーの選択`)
};

const hi_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट परिवार का चयन`)
};

const pt_pt2_video_export_font_family_aria = /** @type {(inputs: Video_Export_Font_Family_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de Família de Fontes`)
};

/**
* | output |
* | --- |
* | "Font Family Selection" |
*
* @param {Video_Export_Font_Family_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_font_family_aria = /** @type {((inputs?: Video_Export_Font_Family_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Font_Family_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_font_family_aria(inputs)
	if (locale === "de") return de_video_export_font_family_aria(inputs)
	if (locale === "it") return it_video_export_font_family_aria(inputs)
	if (locale === "ru") return ru_video_export_font_family_aria(inputs)
	if (locale === "es") return es_video_export_font_family_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_font_family_aria(inputs)
	if (locale === "ja") return ja_video_export_font_family_aria(inputs)
	if (locale === "hi") return hi_video_export_font_family_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_font_family_aria(inputs)
	return en_video_export_font_family_aria(inputs)
});